import * as R from 'ramda'

export function to_number(value) {
    return R.compose(

        // ggf. Default-Wert zurueckgeben
        R.defaultTo(null),

        // zu `Number` casten
        Number,

        R.cond([
            [R.is(Array),   R.always(undefined)],
            [R.is(Boolean), R.always(undefined)],
            [R.isNil,       R.always(undefined)],
            [R.T,           R.identity],
        ])

    )(value)
}
